export const OPTHINES = {
    voteName: '2020project/2020sportman',
    themeColor: {
      activeBgColor: '#e43524',
      inactiveBgColor: 'white',
    },
    placeholder: '搜索作品名称/姓名',
    tabs: [
      {
        tabName: '作品展示',
        tabPath: '/20200203TCTYSYYDJ/works',
      },
      {
        tabName: '我要报名',
        tabPath: '/20200203TCTYSYYDJ/signUp',
      },
      {
        tabName: '参与方式',
        tabPath: '/20200203TCTYSYYDJ/rules',
      },
      {
        tabName: '相关新闻',
        tabPath: '/20200203TCTYSYYDJ/relativeNews',
      },
    ],
    mustSearch: 'Button',
    buttonBg: 'rgb(100, 134,205 )',
    // number: {
    //   mustRank: false,
    // },
    name: true,
    content: true,
    votes: true,
};

